<app-layout>
  <app-voltar route="listagem/estoque/produtos" />
  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>
  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input label="Nome do Produto" placeholder="Digite aqui" name="NM_PROD" maxLength="100"
          formControlName="NM_PROD" [requiredInput]="true" [disabled]="disabledForm"></app-input>
        <app-input label="Descrição" placeholder="Digite aqui" name="TX_DESC" maxLength="255"
          formControlName="TX_DESC" [disabled]="disabledForm"></app-input>
        <app-input type="money" label="Valor Unitário" name="VL_UNIT" formControlName="VL_UNIT"
          [requiredInput]="true" [disabled]="disabledForm"></app-input>
        <app-input type="select" label="Unidade de Medida" name="NU_UNID_MED" formControlName="NU_UNID_MED"
          coerceValue="number" [selectData]="unidadeOptions" [requiredInput]="true"
          (ngModelChange)="onSelectChange($event, 'NU_UNID_MED')" [disabled]="disabledForm"></app-input>
        <app-input type="select" label="Status" name="NU_STTS" formControlName="NU_STTS" coerceValue="number"
          [selectData]="statusOptions" [requiredInput]="true" (ngModelChange)="onSelectChange($event, 'NU_STTS')"
          [disabled]="disabledForm"></app-input>
        <app-input type="number" label="Estoque Mínimo" name="QT_ESTQ_MIN" formControlName="QT_ESTQ_MIN"
          [requiredInput]="true" [disabled]="disabledForm"></app-input>
      </div>
      <app-botao type="cadastro" class="botao-cadastro" *ngIf="!disabledForm"
        [text]="isEditing ? 'Salvar Produto' : 'Cadastrar Produto'" (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
